import { CanActivateFn } from "@angular/router";
import { inject } from "@angular/core";
import { JwtHelperService } from "@auth0/angular-jwt";
import { Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import {EAccessType} from "../enums/access-type.enum";
import {IAccessTokenPayload} from "../interfaces/access-token.interface";
import {accessDefaultRoutesMap} from "../config/access-route-map.config";


export const accessTokenGuard: CanActivateFn = async (route, state) => {
  const jwtHelper = inject(JwtHelperService);
  const authService = inject(AuthService);
  const router = inject(Router);

  const allowedAccessToken: EAccessType[] = [].concat(route.data["allowedAccessToken"] || []);
  const requiredPermissions: string[] = [].concat(route.data["requiredPermissions"] || []);

  const token = authService.getToken();
  const user = authService.getUser();

  if (token && jwtHelper.isTokenExpired(token as string)) {
    await authService.logout();
    return state.url === "/auth/login";
  }

  const parsedToken = jwtHelper.decodeToken(token as string) as IAccessTokenPayload;

  if (allowedAccessToken.length && (!parsedToken?.accessType || !allowedAccessToken.includes(parsedToken.accessType))) {
    const targetRoute = accessDefaultRoutesMap[parsedToken?.accessType!] ?? "/auth/login";
    await router.navigate([targetRoute], { queryParamsHandling: "merge" });
    return false;
  }

  if (requiredPermissions.length && (!user || !user?.can(requiredPermissions))) {
    await router.navigate(user ? ["/auth/unauthorized"] : ['/auth/login']);
    return false;
  }

  return true ;
};


